import { gql } from '../../../apollo/__generated__';

export const UPDATE_PLACE = gql(`
  mutation UpdatePlace($updatePlaceInput: UpdatePlaceInput!) {
    updatePlace(updatePlaceInput: $updatePlaceInput) {
      id
      name
      address
    }
  }
`);
